/**
 * 品牌配置：换品牌只改这个文件。
 * 图标资源在 src/web/assets/brand-logo.png（深色版）/brand-logo-white.png（浅色版）。
 */
export const BRAND_NAME = "Dubhe";
export const BRAND_TAGLINE = "安全收银台";
export const BRAND_ADMIN_SUBTITLE = "收款网关";
